const decodeFileName = (fileName: string): string => {
  const plusAsSpace = fileName.replace(/\+/g, ' ')
  try {
    return decodeURIComponent(plusAsSpace)
  } catch {
    return plusAsSpace
  }
}

const extractFileName = (url: string): string => {
  if (!url) return 'Document'

  const parts = url.split('/')
  const lastPart = parts[parts.length - 1] || 'Document'
  const withoutQuery = lastPart.split('?')[0] || 'Document'

  return decodeFileName(withoutQuery) || 'Document'
}

export default extractFileName
